import { Address, BasisType, ProductsCompany, CustomerType } from "@raskrask-dk/raskrask-utils";
import {Next, PickProduct} from "./actions";

export type CompanyProductPickActions = Next | PickProduct;

const companyProductPickActionz = [Next, PickProduct] as const;

export type companyProductPickActions = typeof companyProductPickActionz[number];

export {companyProductPickActionz, Next, PickProduct};

export interface CompanyProductPickStateDependencies {
  address: Address;
  basisType: BasisType;
}

export interface IGetData {
  productType: ProductsCompany | undefined;
  address: Address;
  basisType: BasisType;
  customerType: CustomerType;
}
